import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import i18n from "eth-common/i18n/i18n";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalTitle,
  Table,
} from "react-bootstrap";
import { StartSigning } from "./StartSigning";
import { FetchWithAuth } from "digimaker-ui/util";
import { SigningDetail } from "eth-common/signature/SigningDetail";

export const SignaturePanel = (props: { report: any }) => {
  const { report } = props;

  const [loading, setLoading] = useState(true);
  const [signatureData, setSignatureData] = useState<any>(null);

  const fetchSignatureData = () => {
    FetchWithAuth(
      "eth/signing/get-signature-record/" + report.location.id
    ).then((data) => {
      setSignatureData(data.data);
      setLoading(false);
    });
  };

  useEffect(() => {
    fetchSignatureData();
  }, []);

  if (loading) {
    return <span className="loading"></span>;
  }

  return (
    <div style={{ marginTop: 10 }}>
      <div style={{ marginBottom: 10 }}>
        Signing status: &nbsp;{" "}
        <span
          style={{ border: "1px solid #666666", padding: 5, borderRadius: 4 }}
        >
          {!signatureData || signatureData.status === 0 ? "Not started" : ""}
          {signatureData && signatureData.status === 2 ? "Signing" : ""}
          {signatureData && signatureData.status === 1
            ? "Signing complete"
            : ""}
        </span>
      </div>
      {signatureData &&
        (signatureData.status === 2 ||
          (signatureData.status === 1 && <SigningDetail report={report} />))}

      {(!signatureData || signatureData.status === 0) && (
        <StartSigning
          report={props.report}
          onSuccess={() => fetchSignatureData()}
        />
      )}
    </div>
  );
};
